import {MapSVG} from "../Core/globals.js";
import {MapObject} from "../MapObject/MapObject.js";
import {Location, SVGPoint, GeoPoint} from "../Location/Location.js";
import {ViewBox} from "../Map/MapOptionsInterface.js";
import {CustomObject} from "../Object/CustomObject.js";
import {type} from "os";
const $ = jQuery;

/**
 * Marker class
 * @extends MapObject
 * @param params
 * @constructor
 *
 * @example
 * var location = new MapSVG.Location({
 *   lat: 55.22,
 *   lng: 64.12,
 *   img: "/path/to/image.png"
 *  });
 *
 * var marker = new MapSVG.Marker({
 *   location: location,
 *   mapsvg: mapsvgInstance
 * });
 *
 * // The marker is created but still not added to the map. Let's add it:
 * mapsvg.markerAdd(marker);
 *
 */
export class Marker extends MapObject {

    src: string;
    location: Location;
    svgPoint?: SVGPoint;
    geoPoint?: GeoPoint;
    element: HTMLElement;
    textLabel: HTMLElement;
    width: number;
    height: number;
    selected: boolean;
    object: CustomObject;
    centered: boolean;
    altAttr: string;
    private svgPointBeforeDrag: SVGPoint;

    mapped?: boolean;
    needToRemove?: boolean;
    dragging?: boolean;
    bubble: HTMLElement;
    bubbleMode: boolean;

    constructor(params) {
        super(null, params.mapsvg);

        this.src = params.location.getMarkerImageUrl();
        var img = $('<img src="' + this.src + '" />').addClass('mapsvg-marker');
        this.element = img[0];

        this.location = params.location;
        this.location.marker = this;
        this.mapsvg = params.mapsvg;
        params.object && this.setObject(params.object);

        if (params.width && params.height) {
            this.width = params.width;
            this.height = params.height;
        }

        this.setId(this.mapsvg.markerId());

        this.svgPoint = this.location.svgPoint || this.mapsvg.convertGeoToSVG(this.location.geoPoint);

        this.setImage(this.src);

        this.setAltAttr();

        this.setBubbleMode();

        // this.adjustPosition();
        // this.mapsvg.markerAdd(this);
    }

    /**
     * Set ID of the Marker
     * @param {string} id
     */
    setId(id: string|number) {
        MapObject.prototype.setId.call(this, id);
        this.mapsvg.markers.reindex();
    };
    /**
     * Get SVG bounding box of the Marker
     * @returns {ViewBox}
     */
    getBBox(): ViewBox {
        var bbox = {x: this.svgPoint.x, y: this.svgPoint.y, width: this.width / this.mapsvg.scale, height: this.height / this.mapsvg.scale};
        bbox = $.extend(true, {}, bbox);
        return new ViewBox(bbox);
    };
    /**
     * Get Marker options
     * @returns {{id: string, src: string, x: number, y: number, geoCoords: GeoPoint}}
     */
    getOptions(){
        var o = {
            id: this.id,
            src: this.src,
            svgPoint: this.svgPoint,
            geoPoint: this.geoPoint
        };
        $.each(o, function (key, val) {
            if (val == undefined) {
                delete o[key];
            }
        });
        return o;
    };
    /**
     * Update marker settings
     * @param {object} data - Options
     */
    update = function (data) {
        for (var key in data) {
            // check if there's a setter for a property
            var setter = 'set' + MapSVG.ucfirst(key);
            if (setter in this)
                this[setter](data[key]);
        }
    };
    /**
     * Set image of the Marker
     * @param {string} src
     */
    setImage(src: string) {
        if (!src)
            return false;
        var _this = this;
        src = MapSVG.safeURL(src);
        var img = new Image();
        var marker = this;
        this.src = src;
        if (marker.element.getAttribute('src') !== 'src') {
            marker.element.setAttribute('src', src);
        }
        img.onload = function () {
            marker.width = (<HTMLImageElement>this).width;
            marker.height = (<HTMLImageElement>this).height;
            _this.adjustPosition();
        };
        img.src = src;
        if (this.location) {
            this.location.setImage(src);
        }

    };

    /**
     * Set 'alt' attribute of the Marker
     */
    setAltAttr(){
        var marker = this;

        marker.altAttr = (typeof marker.object != 'undefined') && (typeof marker.object.title != 'undefined')&&(marker.object.title !== '') ? marker.object.title : marker.id;
        marker.element.setAttribute('alt', marker.altAttr);
    };

    /**
     * Set x/y coordinates of the Marker
     * @param {SVGPoint} svgPoint
     */
    setPoint(svgPoint: SVGPoint) {

        this.svgPoint = svgPoint;

        if (this.location) {
            this.location.setSvgPoint(this.svgPoint);
        }
        if (this.mapsvg.mapIsGeo) {
            this.geoPoint = this.mapsvg.convertSVGToGeo(this.svgPoint);
            this.location.setGeoPoint(this.geoPoint);
        }

        this.adjustPosition();
        this.events.trigger('change');
    };
    /**
     * Moves marker to a point.
     * @private
     * @param {Array} xy
     */
    /*
    moveToClick = function (screen) {

        var _data = this.mapsvg.getData();
        var markerOptions = {};

        xy[0] = xy[0] + _data.viewBox[0];
        xy[1] = xy[1] + _data.viewBox[1];


        if (_data.mapIsGeo)
            this.geoCoords = this.mapsvg.convertSVGToGeo(xy[0], xy[1]);

        markerOptions.xy = xy;
        this.update(markerOptions);
    };
     */
    /**
     * Adjusts position of the Marker. Called on map zoom and on map container resize.
     */
    adjustPosition() {
        var _this = this;
        var pos = _this.mapsvg.convertSVGToPixel(this.svgPoint);

        if (pos.x > 30000000) {
            this.element.style.left = pos.x - 30000000 + 'px';
            pos.x = 30000000;
            if (this.textLabel) {
                this.textLabel.style.left = pos.x - 30000000 + 'px';
            }
        } else {
            this.element.style.left = '0';
        }
        if (pos.y > 30000000) {
            this.element.style.top = pos.y - 30000000 + 'px';
            pos.y = 30000000;
            if (this.textLabel) {
                this.textLabel.style.top = pos.y - 30000000 + 'px';
            }
        } else {
            this.element.style.top = '0';
        }

        pos.x -= this.width / 2;
        pos.y -= !this.centered ? this.height : this.height / 2;
        pos.x = Math.round(pos.x);
        pos.y = Math.round(pos.y);

        this.element.style.transform = 'translate(' + pos.x + 'px,' + pos.y + 'px)';

        if (this.textLabel) {
            var x = Math.round(pos.x + this.width / 2 - $(this.textLabel).outerWidth() / 2);
            var y = Math.round(pos.y - $(this.textLabel).outerHeight());
            this.textLabel.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        }
    };
    /**
     * Marker drag event handler
     * @private
     * @param startCoords
     * @param scale
     * @param endCallback
     * @param clickCallback
     */
    drag (startCoords, scale, endCallback?: Function, clickCallback?: Function) {
        var _this = this;
        this.svgPointBeforeDrag = new SVGPoint(this.svgPoint.x, this.svgPoint.y);
        this.dragging = true;

        $('body').on('mousemove.drag.mapsvg', function (e) {
            e.preventDefault();
            $(_this.mapsvg.containers.map).addClass('no-transitions');
            //$('body').css('cursor','move');
            var mouseNew = MapSVG.mouseCoords(e);
            var dx = mouseNew.x - startCoords.x;
            var dy = mouseNew.y - startCoords.y;
            var newSvgPoint = new SVGPoint(_this.svgPointBeforeDrag.x + dx / scale, _this.svgPointBeforeDrag.y + dy / scale);
            _this.setPoint(newSvgPoint);
        });
        $('body').on('mouseup.drag.mapsvg', function (e) {
            e.preventDefault();
            _this.undrag();
            var mouseNew = MapSVG.mouseCoords(e);
            var dx = mouseNew.x - startCoords.x;
            var dy = mouseNew.y - startCoords.y;
            var newSvgPoint = new SVGPoint(_this.svgPointBeforeDrag.x + dx / scale, _this.svgPointBeforeDrag.y + dy / scale);

            _this.setPoint(newSvgPoint);

            if (_this.mapsvg.isGeo()){
                // var svgPoint = new SVGPoint(_this.x + _this.width / 2, this.y + (this.height-1));
                _this.geoPoint = _this.mapsvg.convertSVGToGeo(newSvgPoint);
            }

            endCallback && endCallback.call(_this);
            if (_this.svgPointBeforeDrag.x == _this.svgPoint.x && _this.svgPointBeforeDrag.y == _this.svgPoint.y)
                clickCallback && clickCallback.call(_this);
        });
    };
    /**
     * Marker undrag event handler
     * @private
     */
    undrag () {
        //$(this.element).closest('svg').css('pointer-events','auto');
        //$('body').css('cursor','default');
        this.dragging = false;
        $('body').off('.drag.mapsvg');
        $(this.mapsvg.containers.map).removeClass('no-transitions');
    };
    /**
     * Deletes the Marker
     */
    delete () {
        if (this.textLabel) {
            this.textLabel.remove();
            this.textLabel = null;
        }
        $(this.element).empty().remove();
        this.mapsvg.markerDelete(this);
    };
    /**
     * Sets parent DB object of the Marker
     * @param {object} obj
     */
    setObject(obj: CustomObject) {
        this.object = obj;
        $(this.element).attr('data-object-id', this.object.id);
    };
    /**
     * Hides the Marker
     */
    hide() {
        $(this.element).addClass('mapsvg-marker-hidden');
        if (this.textLabel) {
            $(this.textLabel).hide();
        }
    };
    /**
     * Shows the Marker
     */
    show() {
        $(this.element).removeClass('mapsvg-marker-hidden');
        if (this.textLabel) {
            $(this.textLabel).show();
        }
    };

    /**
     * Highlight the Marker.
     * Used on mouseover.
     */
    highlight() {
        $(this.element).addClass('mapsvg-marker-hover');
    };
    /**
     * Unhighlight the Marker.
     * Used on mouseout.
     */
    unhighlight() {
        $(this.element).removeClass('mapsvg-marker-hover');
    };
    /**
     * Select the Marker.
     */
    select() {
        this.selected = true;
        $(this.element).addClass('mapsvg-marker-active');
    };
    /**
     * Deselect the Marker.
     */
    deselect() {
        this.selected = false;
        $(this.element).removeClass('mapsvg-marker-active');
    };

    getData(){
        return this.object;
    }
    /**
     * Returns color of the choropleth marker bubble
     * @returns {string} color
     */
    getChoroplethColor(){
        let markerValue = parseFloat(this.object[this.mapsvg.options.choropleth.sourceField]),
            color;

        if (!markerValue){
            color = this.mapsvg.options.choropleth.coloring.noData.color;
        }
        else if (this.mapsvg.options.choropleth.coloring.mode === 'gradient'){
            // Gradient mode
            let gradient = this.mapsvg.options.choropleth.coloring.gradient,
                w = gradient.values.maxAdjusted === 0 ? 0 : (markerValue - gradient.values.min) / gradient.values.maxAdjusted,
                r = Math.round(gradient.colors.diffRGB.r * w + gradient.colors.lowRGB.r),
                g = Math.round(gradient.colors.diffRGB.g * w + gradient.colors.lowRGB.g),
                b = Math.round(gradient.colors.diffRGB.b * w + gradient.colors.lowRGB.b),
                a = (gradient.colors.diffRGB.a * w + gradient.colors.lowRGB.a).toFixed(2);

            color = 'rgba(' + r + ',' + g + ',' + b + ',' + a+')';
        }
        else {
            // Palette mode
            let paletteColors = this.mapsvg.options.choropleth.coloring.palette.colors;

            if (!paletteColors[0].valueFrom && markerValue < paletteColors[0].valueTo){
                color = paletteColors[0].color;
            }
            else if (!paletteColors[paletteColors.length-1].valueTo && markerValue > paletteColors[paletteColors.length-1].valueFrom){
                color = paletteColors[paletteColors.length-1].color;
            }
            else {
                paletteColors.forEach(function (paletteColor) {
                    if (markerValue >= paletteColor.valueFrom && markerValue < paletteColor.valueTo){
                        color = paletteColor.color;
                    }
                });

                color = color ? color : this.mapsvg.options.choropleth.coloring.palette.outOfRange.color;
            }
        }

        return color;
    };

    /**
     * Returns size of the choropleth bubble
     */
    getBubbleSize(){
        let bubbleSize;

        if (this.object[this.mapsvg.options.choropleth.sourceField]){
            let maxBubbleSize = Number(this.mapsvg.options.choropleth.bubbleSize.max),
                minBubbleSize = Number(this.mapsvg.options.choropleth.bubbleSize.min),
                maxSourceFieldvalue = this.mapsvg.options.choropleth.coloring.gradient.values.max,
                minSourceFieldvalue = this.mapsvg.options.choropleth.coloring.gradient.values.min,
                sourceFieldvalue = parseFloat(this.object[this.mapsvg.options.choropleth.sourceField]);

            bubbleSize = ((sourceFieldvalue - minSourceFieldvalue)/(maxSourceFieldvalue - minSourceFieldvalue))*(maxBubbleSize - minBubbleSize) + Number(minBubbleSize);
        }
        else {
            bubbleSize = false;
        }

        return bubbleSize;
    }

    /**
     * Returns screen point of the choropleth bubble
     */
    getBubbleScreenPosition(){
        let bubbleSize = Number(this.getBubbleSize());

        let pos = this.mapsvg.convertSVGToPixel(this.svgPoint);

        pos.x -= bubbleSize / 2;
        pos.y -= bubbleSize / 2;
        pos.x = Math.round(pos.x);
        pos.y = Math.round(pos.y);

        return pos;
    }

    /**
     * Draw a choropleth bubble for the marker
     */
    drawBubble() {
        let bubbleId = 'mapsvg-bubble-'+this.object.id;
        let bubbleValue = parseFloat(this.object[this.mapsvg.options.choropleth.sourceField]);

        if (bubbleValue){
            if ($('#'+bubbleId).length === 0) {
                this.bubble = $('<div id="'+bubbleId+'" data-marker-id="'+this.element.id+'" class="mapsvg-bubble mapsvg-marker-bubble"></div>')[0];
                $(this.mapsvg.layers.markers).append(this.bubble);
            }

            let color = this.getChoroplethColor(),
                bubbleSize = Number(this.getBubbleSize()),
                pos = this.getBubbleScreenPosition();

            $(this.bubble).css('transform', 'translate(' + pos.x + 'px,' + pos.y + 'px)')
                .css('background-color', color)
                .css('width', bubbleSize+'px')
                .css('height', bubbleSize+'px')
                .css('lineHeight', (bubbleSize-2)+'px');

            this.setBubblePropagateEvents(true);
        }
        else {
            $('#'+bubbleId).remove();
        }

    }

    /**
     * Disable/enable BubbleMode for the marker
     *
     */
    setBubbleMode(){
        this.bubbleMode = this.mapsvg.options.choropleth.on && this.mapsvg.options.choropleth.source == 'database' && this.mapsvg.options.choropleth.bubbleMode;

        if (this.bubbleMode){
            this.drawBubble();
        }
    }

    /**
     * Set triggering markers events on the bubble
     *
     * @param state
     */
    setBubblePropagateEvents(state){
       const _this = this;
        if (state){

            // TODO Vyachelsav
       }
    }
}
